"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = { class: "scheduling-module" };
var _hoisted_2 = { class: "page-tab-bar top-tab-bar" };
var _hoisted_3 = {
    class: "page-tabs",
    role: "tablist"
};
var _hoisted_4 = ["aria-selected"];
var _hoisted_5 = ["aria-selected"];
var _hoisted_6 = {
    key: 0,
    class: "page-tab-bar"
};
var _hoisted_7 = {
    class: "page-tabs",
    role: "tablist"
};
var _hoisted_8 = ["aria-selected"];
var _hoisted_9 = ["aria-selected"];
var _hoisted_10 = {
    key: 0,
    class: "tab-settings-wrap"
};
var _hoisted_11 = {
    key: 0,
    class: "settings-dropdown"
};
var _hoisted_12 = { class: "settings-item" };
var _hoisted_13 = ["title"];
var _hoisted_14 = { class: "settings-item" };
var _hoisted_15 = ["disabled", "title"];
var _hoisted_16 = { class: "settings-item" };
var _hoisted_17 = ["value", "disabled"];
var _hoisted_18 = {
    key: 0,
    class: "settings-perm-alert"
};
var _hoisted_19 = { class: "module-header" };
var _hoisted_20 = { class: "header-title" };
var _hoisted_21 = { class: "header-controls" };
var _hoisted_22 = { class: "caregiver-type-wrap" };
var _hoisted_23 = {
    key: 0,
    class: "shift-preset-wrap"
};
var _hoisted_24 = { class: "checkbox-line shift-preset-checkbox" };
var _hoisted_25 = ["checked"];
var _hoisted_26 = {
    class: "shift-preset-toggle",
    role: "group",
    "aria-label": "Shift preset"
};
var _hoisted_27 = { class: "staff-select-wrap" };
var _hoisted_28 = { class: "staff-type-label" };
var _hoisted_29 = ["value"];
var _hoisted_30 = {
    key: 1,
    class: "staff-select-wrap"
};
var _hoisted_31 = { class: "staff-type-label" };
var _hoisted_32 = { class: "locked-staff-name" };
var _hoisted_33 = { class: "module-body" };
var _hoisted_34 = { class: "left-column" };
var _hoisted_35 = {
    key: 0,
    class: "panel shift-panel"
};
var _hoisted_36 = { class: "panel-header" };
var _hoisted_37 = { class: "shift-header-left" };
var _hoisted_38 = { class: "panel-sub" };
var _hoisted_39 = { class: "shift-body" };
var _hoisted_40 = { class: "shift-fields" };
var _hoisted_41 = { class: "shift-field" };
var _hoisted_42 = ["value"];
var _hoisted_43 = { class: "shift-field" };
var _hoisted_44 = ["value"];
var _hoisted_45 = { class: "shift-field" };
var _hoisted_46 = ["value"];
var _hoisted_47 = { class: "shift-field" };
var _hoisted_48 = { class: "max-hours-wrap" };
var _hoisted_49 = { class: "shift-save-row" };
var _hoisted_50 = ["disabled"];
var _hoisted_51 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var _hoisted_52 = {
    key: 1,
    class: "glyphicon glyphicon-floppy-disk"
};
var _hoisted_53 = { class: "panel availability-panel" };
var _hoisted_54 = { class: "panel-header" };
var _hoisted_55 = { class: "panel-sub" };
var _hoisted_56 = { class: "weekly-grid" };
var _hoisted_57 = { class: "day-rules" };
var _hoisted_58 = { class: "rule-time" };
var _hoisted_59 = { class: "rule-slot" };
var _hoisted_60 = ["onClick"];
var _hoisted_61 = ["onClick"];
var _hoisted_62 = ["onClick"];
var _hoisted_63 = { class: "right-column" };
var _hoisted_64 = { class: "panel timeoff-panel" };
var _hoisted_65 = { class: "panel-header" };
var _hoisted_66 = {
    key: 0,
    class: "empty-state"
};
var _hoisted_67 = { class: "timeoff-date" };
var _hoisted_68 = { class: "to-day" };
var _hoisted_69 = { class: "to-range" };
var _hoisted_70 = { class: "timeoff-reason" };
var _hoisted_71 = { class: "timeoff-actions" };
var _hoisted_72 = ["onClick"];
var _hoisted_73 = ["onClick"];
var _hoisted_74 = { class: "panel preview-panel" };
var _hoisted_75 = { class: "preview-controls" };
var _hoisted_76 = ["min"];
var _hoisted_77 = {
    key: 0,
    class: "preview-loading"
};
var _hoisted_78 = {
    key: 1,
    class: "empty-state"
};
var _hoisted_79 = {
    key: 2,
    class: "preview-slots"
};
var _hoisted_80 = ["title"];
var _hoisted_81 = {
    key: 3,
    class: "shift-blocks"
};
var _hoisted_82 = { class: "shift-block-time" };
var _hoisted_83 = { class: "shift-start" };
var _hoisted_84 = { class: "shift-end" };
var _hoisted_85 = { class: "shift-dur-badge" };
var _hoisted_86 = { class: "shift-status-label" };
var _hoisted_87 = { class: "preview-legend" };
var _hoisted_88 = { class: "edit-modal" };
var _hoisted_89 = { class: "edit-header" };
var _hoisted_90 = { class: "edit-body" };
var _hoisted_91 = { class: "field-row" };
var _hoisted_92 = { class: "field" };
var _hoisted_93 = { class: "field" };
var _hoisted_94 = { class: "field" };
var _hoisted_95 = ["value"];
var _hoisted_96 = {
    key: 0,
    class: "form-error"
};
var _hoisted_97 = { class: "edit-footer" };
var _hoisted_98 = ["disabled"];
var _hoisted_99 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var _hoisted_100 = {
    key: 1,
    class: "glyphicon glyphicon-floppy-disk"
};
var _hoisted_101 = { class: "edit-modal" };
var _hoisted_102 = { class: "edit-header" };
var _hoisted_103 = { class: "edit-body" };
var _hoisted_104 = {
    key: 0,
    class: "field"
};
var _hoisted_105 = ["min"];
var _hoisted_106 = { key: 1 };
var _hoisted_107 = { class: "to-cal" };
var _hoisted_108 = { class: "to-cal-header" };
var _hoisted_109 = { class: "cal-month-label" };
var _hoisted_110 = { class: "to-cal-grid" };
var _hoisted_111 = ["title", "onClick"];
var _hoisted_112 = ["disabled", "onClick"];
var _hoisted_113 = {
    key: 0,
    class: "selected-dates-wrap"
};
var _hoisted_114 = { class: "selected-label" };
var _hoisted_115 = { class: "selected-chips" };
var _hoisted_116 = ["onClick"];
var _hoisted_117 = { class: "checkbox-line" };
var _hoisted_118 = {
    key: 2,
    class: "field-row"
};
var _hoisted_119 = { class: "field" };
var _hoisted_120 = { class: "field" };
var _hoisted_121 = { class: "field" };
var _hoisted_122 = {
    key: 3,
    class: "form-error"
};
var _hoisted_123 = { class: "edit-footer" };
var _hoisted_124 = ["disabled"];
var _hoisted_125 = {
    key: 0,
    class: "glyphicon glyphicon-refresh spinning"
};
var _hoisted_126 = {
    key: 1,
    class: "glyphicon glyphicon-floppy-disk"
};
var _hoisted_127 = { class: "page-tab-bar sched-sub-tab-bar" };
var _hoisted_128 = {
    key: 0,
    class: "page-tabs",
    role: "tablist"
};
var _hoisted_129 = ["aria-selected"];
var _hoisted_130 = ["aria-selected"];
var _hoisted_131 = { class: "tab-settings-wrap" };
var _hoisted_132 = {
    key: 0,
    class: "settings-dropdown"
};
var _hoisted_133 = { class: "settings-item" };
var _hoisted_134 = ["disabled", "title"];
var _hoisted_135 = {
    key: 0,
    class: "settings-perm-alert"
};
var _hoisted_136 = {
    key: 0,
    class: "toast"
};
var vue_3 = require("vue");
var vuex_1 = require("vuex");
var patientCardsStore_1 = require("../../../stores/patientCardsStore");
var privileges_1 = require("../../../stores/privileges");
var privileges_2 = require("@/constants/privileges");
var privilegesApi_1 = require("@/api/privilegesApi");
var useSchedulingAccess_1 = require("@/composables/useSchedulingAccess");
var PatientAvailability_vue_1 = require("./PatientAvailability.vue");
var appointmentApiService_1 = require("../../../services/appointmentApiService");
var SchedulingCalendar_vue_1 = require("./SchedulingCalendar.vue");
var MasterCalendar_vue_1 = require("./MasterCalendar.vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ManageScheduling',
    setup: function (__props) {
        var _this = this;
        var store = (0, patientCardsStore_1.usePatientCardsStore)();
        var privStore = (0, privileges_1.usePrivilegesStore)();
        var vustore = (0, vuex_1.useStore)();
        var allData = (0, vue_3.computed)(function () { return vustore.getters['login/getAllData']; });
        // Read the initial `view` query param without vue-router's useRoute() — this
        // app uses hash history and useRoute() isn't reliably available this deep in
        // the private layout (only used successfully at one public top-level route
        // elsewhere in the codebase). Plain URL parsing has no such dependency.
        function getInitialQueryParam(name) {
            var hash = window.location.hash || '';
            var queryIndex = hash.indexOf('?');
            var search = queryIndex >= 0 ? hash.slice(queryIndex) : window.location.search;
            return new URLSearchParams(search).get(name);
        }
        var staffContext = (0, vue_3.computed)(function () {
            var _a = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(allData.value), accountnumber = _a.accountnumber, unique_ID = _a.unique_ID;
            return { externId: unique_ID, externId2: accountnumber };
        });
        /* ── Permission-scoped access (patient / caregiver / admin) ────────── */
        var access = (0, useSchedulingAccess_1.useSchedulingAccess)().access;
        /* ── Top-level module tabs (Availability vs Scheduling) ──────────── */
        var topTab = (0, vue_3.ref)('availability');
        var schedulingSubTab = (0, vue_3.ref)('appointments');
        // The Appointments tab is the full staff booking screen — it can schedule
        // for ANY patient, which makes no sense for a patient/family-in-chart
        // session even once they're granted scheduling privilege. A patient books
        // only for themselves, via the interactive Master Calendar (click an empty
        // slot) — so Appointments stays hidden for every patient session,
        // regardless of canAdd. Only admin/caregiver sessions ever see it.
        var canAccessAppointmentsTab = (0, vue_3.computed)(function () { var _a; return ((_a = access.value) === null || _a === void 0 ? void 0 : _a.kind) !== 'patient'; });
        // Settings gear (supporting-cards toggle) is a *separate* gate from the
        // Appointments tab above — a patient with scheduling privilege still can't
        // see Appointments, but should still be able to configure their own
        // Calendar view. Mirrors the privilege check the old combined flag used.
        var canAccessCalendarSettings = (0, vue_3.computed)(function () { var _a; return ((_a = access.value) === null || _a === void 0 ? void 0 : _a.kind) !== 'patient' || access.value.canAdd; });
        var schedulingCalendarRef = (0, vue_3.ref)(null);
        function onEditInScheduler(ev) {
            return __awaiter(this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            schedulingSubTab.value = 'appointments';
                            return [4 /*yield*/, (0, vue_3.nextTick)()];
                        case 1:
                            _b.sent();
                            (_a = schedulingCalendarRef.value) === null || _a === void 0 ? void 0 : _a.focusVisit(ev);
                            return [2 /*return*/];
                    }
                });
            });
        }
        /* ── Page mode (staff scheduling vs patient availability) ───────── */
        var pageMode = (0, vue_3.ref)(getInitialQueryParam('view') === 'patient-availability' ? 'patient' : 'staff');
        /* ── Admin detection via Roles & Privileges ─────────────────────── */
        // Main: admin if any privilege assignment is inherited from a group named
        // "Administrators". The port's session (GET /me) carries the permissions and
        // no group provenance, so that test was always false here and the settings
        // gear refused everyone. The Administrators template grants scheduling:admin,
        // and every setting behind the gear (shift settings, environment tabs, the
        // concurrent-caregiver cap) is a PUT the API admits only with scheduling:admin
        // — so the gate is that permission.
        var isAdmin = (0, vue_3.computed)(function () { return privStore.effectiveGranted(privileges_2.PRIVILEGES.SCHEDULE_ADMINISTER); });
        /* ── Settings panel state ────────────────────────────────────────── */
        var showMatrix = (0, vue_3.ref)(false);
        var settingsOpen = (0, vue_3.ref)(false);
        var permissionAlert = (0, vue_3.ref)(false);
        var _permAlertTimer = null;
        // Off by default — Patient Availability uses the flat 6-context model.
        // Admins can re-enable the In-Home/Inpatient/Clinic-Telehealth sub-tabs here.
        var enableEnvironmentTabs = (0, vue_3.ref)(false);
        // Max caregivers allowed overlapping visits with the same patient at once —
        // independent of the caregiverPairCompat matrix (see appointmentApiService.ts).
        var maxConcurrentCaregivers = (0, vue_3.ref)(2);
        // Whether the Master Calendar's supporting cards (Unavailable Blocks, Today,
        // Upcoming, Parallel Visits Today) show for a patient-kind session — off by
        // default, toggleable via the Scheduling tab's own Settings gear below.
        var showSupportingCards = (0, vue_3.ref)(false);
        var savingUiSettings = (0, vue_3.ref)(false);
        function loadSchedulingUiSettings() {
            return __awaiter(this, void 0, void 0, function () {
                var settings;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, (0, appointmentApiService_1.getSchedulingUiSettings)(staffContext.value.externId2)];
                        case 1:
                            settings = _a.sent();
                            enableEnvironmentTabs.value = settings.enableEnvironmentTabs;
                            maxConcurrentCaregivers.value = settings.maxConcurrentCaregivers;
                            showSupportingCards.value = settings.showSupportingCards;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function toggleEnvironmentTabs() {
            return __awaiter(this, void 0, void 0, function () {
                var next;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            next = { enableEnvironmentTabs: !enableEnvironmentTabs.value, maxConcurrentCaregivers: maxConcurrentCaregivers.value, showSupportingCards: showSupportingCards.value };
                            enableEnvironmentTabs.value = next.enableEnvironmentTabs;
                            savingUiSettings.value = true;
                            return [4 /*yield*/, (0, appointmentApiService_1.saveSchedulingUiSettings)(staffContext.value.externId2, next)];
                        case 1:
                            _a.sent();
                            savingUiSettings.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function saveMaxConcurrentCaregivers(value) {
            return __awaiter(this, void 0, void 0, function () {
                var clamped, previous, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            clamped = Math.min(6, Math.max(1, Math.round(value) || 1));
                            previous = maxConcurrentCaregivers.value;
                            maxConcurrentCaregivers.value = clamped;
                            savingUiSettings.value = true;
                            return [4 /*yield*/, (0, appointmentApiService_1.saveSchedulingUiSettings)(staffContext.value.externId2, { enableEnvironmentTabs: enableEnvironmentTabs.value, maxConcurrentCaregivers: clamped, showSupportingCards: showSupportingCards.value })];
                        case 1:
                            res = _a.sent();
                            savingUiSettings.value = false;
                            if (res.success) {
                                showToast("Max concurrent caregivers set to ".concat(clamped));
                            }
                            else {
                                maxConcurrentCaregivers.value = previous;
                                showToast('Error saving — value reverted');
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function toggleShowSupportingCards() {
            return __awaiter(this, void 0, void 0, function () {
                var next;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            next = { enableEnvironmentTabs: enableEnvironmentTabs.value, maxConcurrentCaregivers: maxConcurrentCaregivers.value, showSupportingCards: !showSupportingCards.value };
                            showSupportingCards.value = next.showSupportingCards;
                            savingUiSettings.value = true;
                            return [4 /*yield*/, (0, appointmentApiService_1.saveSchedulingUiSettings)(staffContext.value.externId2, next)];
                        case 1:
                            _a.sent();
                            savingUiSettings.value = false;
                            return [2 /*return*/];
                    }
                });
            });
        }
        function onSettingsClick() {
            if (!isAdmin.value) {
                permissionAlert.value = true;
                if (_permAlertTimer)
                    clearTimeout(_permAlertTimer);
                _permAlertTimer = setTimeout(function () { permissionAlert.value = false; }, 4000);
                return;
            }
            settingsOpen.value = !settingsOpen.value;
        }
        /* ── Scheduling > Calendar tab Settings gear (supporting-cards toggle) ──── */
        var calendarSettingsOpen = (0, vue_3.ref)(false);
        var calendarPermissionAlert = (0, vue_3.ref)(false);
        var _calendarPermAlertTimer = null;
        function onCalendarSettingsClick() {
            if (!canAccessCalendarSettings.value) {
                calendarPermissionAlert.value = true;
                if (_calendarPermAlertTimer)
                    clearTimeout(_calendarPermAlertTimer);
                _calendarPermAlertTimer = setTimeout(function () { calendarPermissionAlert.value = false; }, 4000);
                return;
            }
            calendarSettingsOpen.value = !calendarSettingsOpen.value;
        }
        /* ── Role & category state ──────────────────────────────────────── */
        var staffRole = (0, vue_3.ref)('provider');
        var activeCategory = (0, vue_3.ref)('provider');
        var selectedStaffId = (0, vue_3.ref)('');
        /* ── Day/Night shift preset (nurse/HHA only) ──────────────────────
         * Purely a prefill convenience for the Add Hours modal (openRuleModal) —
         * not persisted anywhere. 'regular' (default, checkbox checked) leaves the
         * modal's existing 9–5 default untouched; 'day'/'night' seed it with the
         * 7a–7p / 7p–7a templates. The admin can still edit the times freely
         * before saving either way — Parts 1–3's overnight logic works generically
         * off whatever start/end actually gets saved. */
        var shiftPreset = (0, vue_3.ref)('regular');
        function setShiftPreset(preset) {
            shiftPreset.value = preset;
        }
        var weekDays = [
            { value: 1, label: 'Monday' },
            { value: 2, label: 'Tuesday' },
            { value: 3, label: 'Wednesday' },
            { value: 4, label: 'Thursday' },
            { value: 5, label: 'Friday' },
            { value: 6, label: 'Saturday' },
            { value: 0, label: 'Sunday' }
        ];
        var todayStr = new Date().toISOString().split('T')[0];
        var toast = (0, vue_3.ref)('');
        function showToast(msg) {
            toast.value = msg;
            setTimeout(function () { return (toast.value = ''); }, 2600);
        }
        var activeCategoryLabel = (0, vue_3.computed)(function () {
            var map = {
                provider: 'PROVIDERS',
                allied: 'ALLIED PROFESSIONALS',
                nurse: 'NURSE',
                hha: 'HHA'
            };
            return map[activeCategory.value];
        });
        // filterStaffForAccess narrows this to just the caller for a locked
        // caregiver session -- see its own header for why this is centralized
        // rather than checked ad hoc here.
        var filteredStaffList = (0, vue_3.computed)(function () {
            if (activeCategory.value === 'nurse')
                return (0, useSchedulingAccess_1.filterStaffForAccess)(store.nurses.filter(function (n) { return n.category === 'nurse'; }), access.value);
            if (activeCategory.value === 'hha')
                return (0, useSchedulingAccess_1.filterStaffForAccess)(store.nurses.filter(function (n) { return n.category === 'hha'; }), access.value);
            if (activeCategory.value === 'allied')
                return (0, useSchedulingAccess_1.filterStaffForAccess)(store.providers.filter(function (p) { return p.category === 'allied'; }), access.value);
            return (0, useSchedulingAccess_1.filterStaffForAccess)(store.providers.filter(function (p) { return !p.category || p.category === 'provider'; }), access.value);
        });
        var selectedStaffName = (0, vue_3.computed)(function () { var _a, _b; return (_b = (_a = filteredStaffList.value.find(function (s) { return s.id === selectedStaffId.value; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : ''; });
        /* ── Shift settings ─────────────────────────────────────────────── */
        var shiftSettings = (0, vue_3.reactive)({
            groupKey: 'nurse',
            minIncrementMinutes: 120,
            maxIncrementMinutes: 480,
            stepMinutes: 120,
            maxConsecutiveHours: 12
        });
        var savingShiftSettings = (0, vue_3.ref)(false);
        var shiftLengthOptions = (0, vue_3.computed)(function () {
            var opts = [];
            for (var h = 1; h <= 24; h++) {
                opts.push({ value: h * 60, label: "".concat(h, "h") });
            }
            return opts;
        });
        var stepOptions = [
            { value: 30, label: '30 minutes' },
            { value: 60, label: '1 hour' },
            { value: 120, label: '2 hours' },
            { value: 180, label: '3 hours' },
            { value: 240, label: '4 hours' }
        ];
        // Slot options for the rule modal in nurse mode — derived from shiftSettings
        var nurseSlotOptions = (0, vue_3.computed)(function () {
            var opts = [];
            var minIncrementMinutes = shiftSettings.minIncrementMinutes, maxIncrementMinutes = shiftSettings.maxIncrementMinutes, stepMinutes = shiftSettings.stepMinutes;
            for (var m = minIncrementMinutes; m <= maxIncrementMinutes; m += stepMinutes) {
                opts.push({ value: m, label: formatDuration(m) });
            }
            return opts;
        });
        function loadShiftSettings() {
            return __awaiter(this, void 0, void 0, function () {
                var grp, result;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            grp = activeCategory.value === 'hha' ? 'hha' : 'nurse';
                            shiftSettings.groupKey = grp;
                            return [4 /*yield*/, (0, appointmentApiService_1.getNurseShiftSettings)(staffContext.value.externId2, grp)];
                        case 1:
                            result = _a.sent();
                            if (result) {
                                shiftSettings.minIncrementMinutes = result.minIncrementMinutes;
                                shiftSettings.maxIncrementMinutes = result.maxIncrementMinutes;
                                shiftSettings.stepMinutes = result.stepMinutes;
                                shiftSettings.maxConsecutiveHours = result.maxConsecutiveHours;
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        function saveShiftSettingsEntry() {
            return __awaiter(this, void 0, void 0, function () {
                var res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            savingShiftSettings.value = true;
                            return [4 /*yield*/, (0, appointmentApiService_1.saveNurseShiftSettings)(staffContext.value.externId2, __assign({}, shiftSettings))];
                        case 1:
                            res = _a.sent();
                            savingShiftSettings.value = false;
                            if (res.success) {
                                showToast('Shift settings saved');
                                loadPreview();
                            }
                            else {
                                showToast('Error saving shift settings');
                            }
                            return [2 /*return*/];
                    }
                });
            });
        }
        /* ── Category dropdown change ─────────────────────────────────────
         * Single optgrouped <select> (Providers: Physician/Allied Professional —
         * Nurses: Nurse/HHA) replaces the old role toggle + category-filter
         * buttons — v-model="activeCategory" drives it directly, this watcher
         * just keeps everything that used to key off staffRole/setCategory
         * working exactly as before. */
        (0, vue_3.watch)(activeCategory, function (cat) {
            var _a;
            // A caregiver-locked session already sets activeCategory + selectedStaffId
            // together in the `watch(access, ...)` block above — this watcher firing
            // too would race that block's own async setup and could clobber its
            // correctly-locked selectedStaffId with resetStaffSelection()'s "first in
            // the list" default. Skip entirely; that block owns setup for this case.
            if (((_a = access.value) === null || _a === void 0 ? void 0 : _a.kind) === 'caregiver')
                return;
            staffRole.value = (cat === 'nurse' || cat === 'hha') ? 'nurse' : 'provider';
            resetStaffSelection();
            if (staffRole.value === 'nurse')
                loadShiftSettings();
            shiftPreset.value = 'regular';
        });
        function resetStaffSelection() {
            return __awaiter(this, void 0, void 0, function () {
                var list;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            rules.value = [];
                            timeOff.value = [];
                            previewSlots.value = [];
                            if (!(staffRole.value === 'nurse' && store.nurses.length === 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, store.loadNurses()];
                        case 1:
                            _c.sent();
                            _c.label = 2;
                        case 2:
                            list = filteredStaffList.value;
                            selectedStaffId.value = (_b = (_a = list[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
                            return [2 /*return*/];
                    }
                });
            });
        }
        // Non-admin sessions are locked to a single relevant page mode/selection —
        // patients only ever see Patient Availability, caregivers only ever see
        // their own staff canvas (their own role/category/id, not a pickable list).
        // Runs whenever access resolves (async) and again if it changes (e.g.
        // patient chart viewing ends).
        (0, vue_3.watch)(access, function (a) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!a)
                            return [2 /*return*/];
                        if (a.kind === 'patient') {
                            pageMode.value = 'patient';
                            // A patient's own calendar is the relevant landing view — the
                            // Availability tab (staff hours/settings) and the Appointments booking
                            // grid are both staff-oriented and confusing to land on by default.
                            topTab.value = 'scheduling';
                            schedulingSubTab.value = 'calendar';
                            return [2 /*return*/];
                        }
                        if (!(a.kind === 'caregiver')) return [3 /*break*/, 5];
                        pageMode.value = 'staff';
                        activeCategory.value = a.category;
                        staffRole.value = (a.category === 'nurse' || a.category === 'hha') ? 'nurse' : 'provider';
                        if (!(staffRole.value === 'nurse' && store.nurses.length === 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, store.loadNurses()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(staffRole.value === 'provider' && store.providers.length === 0)) return [3 /*break*/, 4];
                        return [4 /*yield*/, store.loadProviders()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        selectedStaffId.value = a.staffId;
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        /* ── Load data for selected staff ───────────────────────────────── */
        var rules = (0, vue_3.ref)([]);
        var timeOff = (0, vue_3.ref)([]);
        function loadStaffData() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!selectedStaffId.value)
                                return [2 /*return*/];
                            _a = rules;
                            return [4 /*yield*/, (0, appointmentApiService_1.getAvailabilityRules)(staffContext.value.externId2, selectedStaffId.value)];
                        case 1:
                            _a.value = _c.sent();
                            _b = timeOff;
                            return [4 /*yield*/, (0, appointmentApiService_1.getTimeOff)(staffContext.value.externId2, selectedStaffId.value)];
                        case 2:
                            _b.value = _c.sent();
                            loadPreview();
                            return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.onMounted)(function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, store.loadProviders()];
                    case 1:
                        _c.sent();
                        selectedStaffId.value = (_b = (_a = store.providers[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : '';
                        return [4 /*yield*/, loadStaffData()];
                    case 2:
                        _c.sent();
                        return [4 /*yield*/, loadSchedulingUiSettings()];
                    case 3:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        }); });
        (0, vue_3.watch)(selectedStaffId, loadStaffData);
        // When category changes we already resetStaffSelection → watch selectedStaffId fires loadStaffData
        /* ── Formatting ─────────────────────────────────────────────────── */
        function formatTime(time) {
            var _a = time.split(':').map(Number), h = _a[0], m = _a[1];
            var period = h >= 12 ? 'PM' : 'AM';
            var dh = h % 12 === 0 ? 12 : h % 12;
            return "".concat(dh, ":").concat(String(m).padStart(2, '0'), " ").concat(period);
        }
        function formatDateShort(dateStr) {
            var _a = dateStr.split('-').map(Number), y = _a[0], m = _a[1], d = _a[2];
            return new Date(y, m - 1, d).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
        }
        function formatDuration(minutes) {
            if (!minutes)
                return '';
            var h = Math.floor(minutes / 60);
            var m = minutes % 60;
            if (h > 0 && m > 0)
                return "".concat(h, "h ").concat(m, "m");
            if (h > 0)
                return "".concat(h, "h");
            return "".concat(m, "m");
        }
        /* ── Availability Rule Modal ─────────────────────────────────────── */
        var ruleModalOpen = (0, vue_3.ref)(false);
        var savingRule = (0, vue_3.ref)(false);
        var ruleError = (0, vue_3.ref)('');
        var editingRule = (0, vue_3.reactive)({
            id: undefined, accountnumber: staffContext.value.externId2,
            dayOfWeek: 1, startTime: '09:00', endTime: '17:00', slotMinutes: 30
        });
        function rulesForDay(day) {
            return rules.value.filter(function (r) { return r.dayOfWeek === day; }).sort(function (a, b) { return a.startTime.localeCompare(b.startTime); });
        }
        function dayLabel(day) {
            var _a, _b;
            return (_b = (_a = weekDays.find(function (d) { return d.value === day; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
        }
        function openRuleModal(day, rule) {
            var _a, _b;
            ruleError.value = '';
            if (rule) {
                editingRule.id = rule.id;
                editingRule.accountnumber = rule.accountnumber;
                editingRule.dayOfWeek = rule.dayOfWeek;
                editingRule.startTime = rule.startTime;
                editingRule.endTime = rule.endTime;
                editingRule.slotMinutes = rule.slotMinutes;
            }
            else {
                editingRule.id = undefined;
                editingRule.dayOfWeek = day;
                if (staffRole.value === 'nurse' && shiftPreset.value === 'day') {
                    editingRule.startTime = '07:00';
                    editingRule.endTime = '19:00';
                }
                else if (staffRole.value === 'nurse' && shiftPreset.value === 'night') {
                    editingRule.startTime = '19:00';
                    editingRule.endTime = '07:00';
                }
                else {
                    editingRule.startTime = '09:00';
                    editingRule.endTime = '17:00';
                }
                // Default slot: 30m for providers, first nurse option for nurses
                editingRule.slotMinutes = staffRole.value === 'nurse'
                    ? ((_b = (_a = nurseSlotOptions.value[0]) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 120)
                    : 30;
            }
            ruleModalOpen.value = true;
        }
        function toMinutes(time) {
            var _a = time.split(':').map(Number), h = _a[0], m = _a[1];
            return h * 60 + m;
        }
        function saveRule() {
            return __awaiter(this, void 0, void 0, function () {
                var newStart, newEnd, isOvernight, windowLen, otherRules, candidateRule, nextDow, candidateDaySegments, _loop_1, _i, candidateDaySegments_1, _a, day, seg, state_1, res, idx;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            // end <= start is now the *signal* for an overnight shift (e.g. 19:00–07:00),
                            // not an error — only reject true zero-length input.
                            if (editingRule.endTime === editingRule.startTime) {
                                ruleError.value = 'End time must be after start time.';
                                return [2 /*return*/];
                            }
                            newStart = toMinutes(editingRule.startTime);
                            newEnd = toMinutes(editingRule.endTime);
                            isOvernight = newEnd <= newStart;
                            windowLen = isOvernight ? (1440 - newStart) + newEnd : newEnd - newStart;
                            otherRules = rules.value.filter(function (r) { return r.id !== editingRule.id; });
                            candidateRule = {
                                id: (_b = editingRule.id) !== null && _b !== void 0 ? _b : '__candidate__',
                                accountnumber: editingRule.accountnumber,
                                providerId: selectedStaffId.value,
                                dayOfWeek: editingRule.dayOfWeek,
                                startTime: editingRule.startTime,
                                endTime: editingRule.endTime,
                                slotMinutes: editingRule.slotMinutes
                            };
                            nextDow = (editingRule.dayOfWeek + 1) % 7;
                            candidateDaySegments = [
                                { day: editingRule.dayOfWeek, seg: (0, appointmentApiService_1.resolveDaySegments)(editingRule.dayOfWeek, [candidateRule])[0] },
                                { day: nextDow, seg: (0, appointmentApiService_1.resolveDaySegments)(nextDow, [candidateRule])[0] }
                            ].filter(function (x) { return !!x.seg; });
                            _loop_1 = function (day, seg) {
                                var overlapping = (0, appointmentApiService_1.resolveDaySegments)(day, otherRules)
                                    .find(function (existing) { return existing.start < seg.end && seg.start < existing.end; });
                                if (overlapping) {
                                    ruleError.value = "Overlaps existing hours ".concat(formatTime(overlapping.rule.startTime), " \u2013 ").concat(formatTime(overlapping.rule.endTime), ".");
                                    return { value: void 0 };
                                }
                            };
                            for (_i = 0, candidateDaySegments_1 = candidateDaySegments; _i < candidateDaySegments_1.length; _i++) {
                                _a = candidateDaySegments_1[_i], day = _a.day, seg = _a.seg;
                                state_1 = _loop_1(day, seg);
                                if (typeof state_1 === "object")
                                    return [2 /*return*/, state_1.value];
                            }
                            // Provider slot length is a fixed appointment duration, so it can never
                            // exceed its own window — that combination silently collapses the whole
                            // window into one un-split slot downstream (computeAvailableSlots), which
                            // then reads as "fully booked" the moment a single appointment lands
                            // anywhere in it. Nurses/HHAs are exempt: their slotMinutes represents a
                            // shift length (can legitimately exceed the window, e.g. a 12h shift) and
                            // are booked through the separate shift-aware slot generator instead,
                            // which doesn't use slotMinutes as a booking increment at all.
                            if (staffRole.value === 'provider' && editingRule.slotMinutes > windowLen) {
                                ruleError.value = "Appointment length (".concat(editingRule.slotMinutes, " min) can't exceed this window's length (").concat(windowLen, " min).");
                                return [2 /*return*/];
                            }
                            savingRule.value = true;
                            return [4 /*yield*/, (0, appointmentApiService_1.saveAvailabilityRule)({
                                    id: editingRule.id,
                                    providerId: selectedStaffId.value,
                                    accountnumber: editingRule.accountnumber,
                                    dayOfWeek: editingRule.dayOfWeek,
                                    startTime: editingRule.startTime,
                                    endTime: editingRule.endTime,
                                    slotMinutes: editingRule.slotMinutes
                                }, staffContext.value.externId)];
                        case 1:
                            res = _c.sent();
                            if (editingRule.id) {
                                idx = rules.value.findIndex(function (r) { return r.id === editingRule.id; });
                                if (idx !== -1) {
                                    rules.value[idx] = __assign(__assign({}, rules.value[idx]), { startTime: editingRule.startTime, endTime: editingRule.endTime, slotMinutes: editingRule.slotMinutes });
                                }
                            }
                            else {
                                rules.value.push({
                                    id: res.id,
                                    accountnumber: staffContext.value.externId2,
                                    providerId: selectedStaffId.value,
                                    dayOfWeek: editingRule.dayOfWeek,
                                    startTime: editingRule.startTime,
                                    endTime: editingRule.endTime,
                                    slotMinutes: editingRule.slotMinutes
                                });
                            }
                            savingRule.value = false;
                            ruleModalOpen.value = false;
                            showToast('Availability hours saved');
                            loadPreview();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function removeRule(id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!confirm('Remove these hours?'))
                                return [2 /*return*/];
                            return [4 /*yield*/, (0, appointmentApiService_1.deleteAvailabilityRule)(staffContext.value.externId2, id, staffContext.value.externId)];
                        case 1:
                            _a.sent();
                            rules.value = rules.value.filter(function (r) { return r.id !== id; });
                            showToast('Hours removed');
                            loadPreview();
                            return [2 /*return*/];
                    }
                });
            });
        }
        /* ── Time Off Modal ──────────────────────────────────────────────── */
        var timeOffModalOpen = (0, vue_3.ref)(false);
        var savingTimeOff = (0, vue_3.ref)(false);
        var timeOffError = (0, vue_3.ref)('');
        var allDayOff = (0, vue_3.ref)(true);
        var editingTimeOff = (0, vue_3.reactive)({
            id: undefined, offDate: todayStr, startTime: null, endTime: null, reason: ''
        });
        var selectedTimeOffDates = (0, vue_3.ref)([]);
        var toCalView = (0, vue_3.reactive)({ year: new Date().getFullYear(), month: new Date().getMonth() });
        var toCalMonthLabel = (0, vue_3.computed)(function () {
            return new Date(toCalView.year, toCalView.month).toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
        });
        function toCalPrevMonth() {
            if (toCalView.month === 0) {
                toCalView.month = 11;
                toCalView.year--;
            }
            else {
                toCalView.month--;
            }
        }
        function toCalNextMonth() {
            if (toCalView.month === 11) {
                toCalView.month = 0;
                toCalView.year++;
            }
            else {
                toCalView.month++;
            }
        }
        var toCalWeeks = (0, vue_3.computed)(function () {
            var today = new Date();
            today.setHours(0, 0, 0, 0);
            var firstDay = new Date(toCalView.year, toCalView.month, 1).getDay();
            var daysInMonth = new Date(toCalView.year, toCalView.month + 1, 0).getDate();
            var cells = [];
            for (var i = 0; i < firstDay; i++)
                cells.push({ dateStr: '', label: '', isPast: false, col: i });
            for (var d = 1; d <= daysInMonth; d++) {
                var dt = new Date(toCalView.year, toCalView.month, d);
                dt.setHours(0, 0, 0, 0);
                var y = toCalView.year, m = String(toCalView.month + 1).padStart(2, '0'), day = String(d).padStart(2, '0');
                cells.push({ dateStr: "".concat(y, "-").concat(m, "-").concat(day), label: String(d), isPast: dt < today, col: dt.getDay() });
            }
            while (cells.length % 7 !== 0)
                cells.push({ dateStr: '', label: '', isPast: false, col: cells.length % 7 });
            var weeks = [];
            for (var i = 0; i < cells.length; i += 7)
                weeks.push(cells.slice(i, i + 7));
            return weeks;
        });
        function toggleTimeOffDate(dateStr) {
            var idx = selectedTimeOffDates.value.indexOf(dateStr);
            if (idx === -1)
                selectedTimeOffDates.value.push(dateStr);
            else
                selectedTimeOffDates.value.splice(idx, 1);
            selectedTimeOffDates.value.sort();
        }
        function toggleTimeOffWeek(week) {
            var valid = week.filter(function (c) { return c.dateStr && !c.isPast; }).map(function (c) { return c.dateStr; });
            var allSel = valid.every(function (d) { return selectedTimeOffDates.value.includes(d); });
            if (allSel) {
                selectedTimeOffDates.value = selectedTimeOffDates.value.filter(function (d) { return !valid.includes(d); });
            }
            else {
                valid.forEach(function (d) { if (!selectedTimeOffDates.value.includes(d))
                    selectedTimeOffDates.value.push(d); });
                selectedTimeOffDates.value.sort();
            }
        }
        function openTimeOffModal(off) {
            timeOffError.value = '';
            selectedTimeOffDates.value = [];
            toCalView.year = new Date().getFullYear();
            toCalView.month = new Date().getMonth();
            if (off) {
                editingTimeOff.id = off.id;
                editingTimeOff.offDate = off.offDate;
                editingTimeOff.startTime = off.startTime || '09:00';
                editingTimeOff.endTime = off.endTime || '17:00';
                editingTimeOff.reason = off.reason || '';
                allDayOff.value = !off.startTime;
            }
            else {
                editingTimeOff.id = undefined;
                editingTimeOff.offDate = todayStr;
                editingTimeOff.startTime = '09:00';
                editingTimeOff.endTime = '17:00';
                editingTimeOff.reason = '';
                allDayOff.value = true;
            }
            timeOffModalOpen.value = true;
        }
        function saveTimeOffEntry() {
            return __awaiter(this, void 0, void 0, function () {
                var payload, idx, datesToSave, results;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!editingTimeOff.id) return [3 /*break*/, 2];
                            if (!editingTimeOff.offDate) {
                                timeOffError.value = 'Please choose a date.';
                                return [2 /*return*/];
                            }
                            if (!allDayOff.value && editingTimeOff.endTime <= editingTimeOff.startTime) {
                                timeOffError.value = 'End time must be after start time.';
                                return [2 /*return*/];
                            }
                            savingTimeOff.value = true;
                            payload = {
                                id: editingTimeOff.id,
                                accountnumber: staffContext.value.externId2,
                                providerId: selectedStaffId.value,
                                offDate: editingTimeOff.offDate,
                                startTime: allDayOff.value ? null : editingTimeOff.startTime,
                                endTime: allDayOff.value ? null : editingTimeOff.endTime,
                                reason: editingTimeOff.reason
                            };
                            return [4 /*yield*/, (0, appointmentApiService_1.saveTimeOff)(payload, staffContext.value.externId)];
                        case 1:
                            _a.sent();
                            idx = timeOff.value.findIndex(function (t) { return t.id === editingTimeOff.id; });
                            if (idx !== -1)
                                timeOff.value[idx] = __assign(__assign({}, payload), { id: editingTimeOff.id });
                            timeOff.value.sort(function (a, b) { return a.offDate.localeCompare(b.offDate); });
                            savingTimeOff.value = false;
                            timeOffModalOpen.value = false;
                            showToast('Time off updated');
                            loadPreview();
                            return [2 /*return*/];
                        case 2:
                            datesToSave = selectedTimeOffDates.value.length ? __spreadArray([], selectedTimeOffDates.value, true) : [editingTimeOff.offDate];
                            if (!datesToSave.length || !datesToSave[0]) {
                                timeOffError.value = 'Please select at least one date.';
                                return [2 /*return*/];
                            }
                            if (!allDayOff.value && editingTimeOff.endTime <= editingTimeOff.startTime) {
                                timeOffError.value = 'End time must be after start time.';
                                return [2 /*return*/];
                            }
                            savingTimeOff.value = true;
                            return [4 /*yield*/, Promise.all(datesToSave.map(function (offDate) {
                                    return (0, appointmentApiService_1.saveTimeOff)({
                                        accountnumber: staffContext.value.externId2,
                                        providerId: selectedStaffId.value,
                                        offDate: offDate,
                                        startTime: allDayOff.value ? null : editingTimeOff.startTime,
                                        endTime: allDayOff.value ? null : editingTimeOff.endTime,
                                        reason: editingTimeOff.reason
                                    }, staffContext.value.externId);
                                }))];
                        case 3:
                            results = _a.sent();
                            results.forEach(function (res, i) {
                                timeOff.value.push({
                                    id: res.id,
                                    providerId: selectedStaffId.value,
                                    offDate: datesToSave[i],
                                    startTime: allDayOff.value ? null : editingTimeOff.startTime,
                                    endTime: allDayOff.value ? null : editingTimeOff.endTime,
                                    reason: editingTimeOff.reason
                                });
                            });
                            timeOff.value.sort(function (a, b) { return a.offDate.localeCompare(b.offDate); });
                            savingTimeOff.value = false;
                            timeOffModalOpen.value = false;
                            showToast("".concat(datesToSave.length, " day").concat(datesToSave.length > 1 ? 's' : '', " of time off saved"));
                            loadPreview();
                            return [2 /*return*/];
                    }
                });
            });
        }
        function removeTimeOff(id) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!confirm('Remove this time off entry?'))
                                return [2 /*return*/];
                            return [4 /*yield*/, (0, appointmentApiService_1.deleteTimeOff)(staffContext.value.externId2, id, staffContext.value.externId)];
                        case 1:
                            _a.sent();
                            timeOff.value = timeOff.value.filter(function (t) { return t.id !== id; });
                            showToast('Time off removed');
                            loadPreview();
                            return [2 /*return*/];
                    }
                });
            });
        }
        /* ── Availability Preview ────────────────────────────────────────── */
        var previewDate = (0, vue_3.ref)(todayStr);
        var previewSlots = (0, vue_3.ref)([]);
        var loadingPreview = (0, vue_3.ref)(false);
        function loadPreview() {
            return __awaiter(this, void 0, void 0, function () {
                var cap, res;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!selectedStaffId.value || !previewDate.value)
                                return [2 /*return*/];
                            loadingPreview.value = true;
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, , 3, 4]);
                            cap = staffRole.value === 'nurse' ? shiftSettings.maxConsecutiveHours : undefined;
                            return [4 /*yield*/, (0, appointmentApiService_1.getAvailability)(staffContext.value.externId2, selectedStaffId.value, previewDate.value, cap)];
                        case 2:
                            res = _a.sent();
                            previewSlots.value = res.slots;
                            console.log('Preview Slots', previewSlots.value);
                            return [3 /*break*/, 4];
                        case 3:
                            loadingPreview.value = false;
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        }
        (0, vue_3.watch)(previewDate, loadPreview);
        // Helper functions for nurse shift block rendering
        function shiftBlockClass(slot) {
            if (slot.booked)
                return 'booked';
            if (slot.capped)
                return 'over-cap';
            if (slot.warning)
                return 'at-cap';
            if (!slot.available)
                return 'time-off';
            return 'open';
        }
        function shiftStatusLabel(slot) {
            if (slot.booked)
                return 'Booked';
            if (slot.capped)
                return 'Over Cap';
            if (slot.warning)
                return 'At Cap';
            if (!slot.available)
                return 'Off';
            return 'Available';
        }
        return function (_ctx, _cache) {
            var _a, _b;
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("button", {
                            role: "tab",
                            "aria-selected": topTab.value === 'availability',
                            class: (0, vue_2.normalizeClass)(['page-tab', { active: topTab.value === 'availability' }]),
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (topTab.value = 'availability'); })
                        }, __spreadArray([], (_cache[39] || (_cache[39] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-calendar2-week" }, null, -1),
                            (0, vue_2.createTextVNode)(" Availability ", -1)
                        ])), true), 10, _hoisted_4),
                        (0, vue_2.createElementVNode)("button", {
                            role: "tab",
                            "aria-selected": topTab.value === 'scheduling',
                            class: (0, vue_2.normalizeClass)(['page-tab', { active: topTab.value === 'scheduling' }]),
                            onClick: _cache[1] || (_cache[1] = function ($event) { return (topTab.value = 'scheduling'); })
                        }, __spreadArray([], (_cache[40] || (_cache[40] = [
                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-calendar-event" }, null, -1),
                            (0, vue_2.createTextVNode)(" Scheduling ", -1)
                        ])), true), 10, _hoisted_5)
                    ])
                ]),
                _cache[115] || (_cache[115] = (0, vue_2.createElementVNode)("div", { class: "tab-separator" }, null, -1)),
                (topTab.value === 'availability')
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                        (((_a = (0, vue_2.unref)(access)) === null || _a === void 0 ? void 0 : _a.kind) === 'admin')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("div", _hoisted_7, [
                                    (0, vue_2.createElementVNode)("button", {
                                        role: "tab",
                                        "aria-selected": pageMode.value === 'staff',
                                        class: (0, vue_2.normalizeClass)(['page-tab', { active: pageMode.value === 'staff' }]),
                                        onClick: _cache[2] || (_cache[2] = function ($event) { return (pageMode.value = 'staff'); })
                                    }, __spreadArray([], (_cache[41] || (_cache[41] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person-badge" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Providers/Nurse Availability ", -1)
                                    ])), true), 10, _hoisted_8),
                                    (0, vue_2.createElementVNode)("button", {
                                        role: "tab",
                                        "aria-selected": pageMode.value === 'patient',
                                        class: (0, vue_2.normalizeClass)(['page-tab', { active: pageMode.value === 'patient' }]),
                                        onClick: _cache[3] || (_cache[3] = function ($event) { return (pageMode.value = 'patient'); })
                                    }, __spreadArray([], (_cache[42] || (_cache[42] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-person" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Patients Availability ", -1)
                                    ])), true), 10, _hoisted_9)
                                ]),
                                (pageMode.value === 'patient')
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, [
                                        (0, vue_2.createElementVNode)("button", {
                                            class: (0, vue_2.normalizeClass)(['tab-settings-btn', { open: settingsOpen.value }]),
                                            onClick: onSettingsClick,
                                            title: "Settings"
                                        }, __spreadArray([], (_cache[43] || (_cache[43] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-gear-fill" }, null, -1),
                                            (0, vue_2.createTextVNode)(" Settings ", -1)
                                        ])), true), 2),
                                        (settingsOpen.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                key: 0,
                                                class: "settings-backdrop",
                                                onClick: _cache[4] || (_cache[4] = function ($event) { return (settingsOpen.value = false); })
                                            }))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createVNode)(vue_2.Transition, { name: "settings-drop" }, {
                                            default: (0, vue_2.withCtx)(function () { return [
                                                (settingsOpen.value)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                                            _cache[45] || (_cache[45] = (0, vue_2.createElementVNode)("span", { class: "settings-label" }, [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-grid-3x3-gap-fill" }),
                                                                (0, vue_2.createTextVNode)(" Compatibility Matrices ")
                                                            ], -1)),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: (0, vue_2.normalizeClass)(['toggle-sw', { on: showMatrix.value }]),
                                                                onClick: _cache[5] || (_cache[5] = function ($event) { return (showMatrix.value = !showMatrix.value); }),
                                                                title: showMatrix.value ? 'Hide matrices' : 'Show matrices'
                                                            }, __spreadArray([], (_cache[44] || (_cache[44] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "toggle-knob" }, null, -1)
                                                            ])), true), 10, _hoisted_13)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                                            _cache[47] || (_cache[47] = (0, vue_2.createElementVNode)("span", { class: "settings-label" }, [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-hospital" }),
                                                                (0, vue_2.createTextVNode)(" Care Setting Tabs (Inpatient / Clinic-Telehealth) ")
                                                            ], -1)),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: (0, vue_2.normalizeClass)(['toggle-sw', { on: enableEnvironmentTabs.value }]),
                                                                onClick: toggleEnvironmentTabs,
                                                                disabled: savingUiSettings.value,
                                                                title: enableEnvironmentTabs.value ? 'Hide care-setting tabs' : 'Show care-setting tabs'
                                                            }, __spreadArray([], (_cache[46] || (_cache[46] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "toggle-knob" }, null, -1)
                                                            ])), true), 10, _hoisted_15)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                            _cache[48] || (_cache[48] = (0, vue_2.createElementVNode)("span", { class: "settings-label" }, [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-people-fill" }),
                                                                (0, vue_2.createTextVNode)(" Max Concurrent Caregivers per Patient ")
                                                            ], -1)),
                                                            (0, vue_2.createElementVNode)("input", {
                                                                type: "number",
                                                                class: "settings-number-input",
                                                                min: "1",
                                                                max: "6",
                                                                value: maxConcurrentCaregivers.value,
                                                                disabled: savingUiSettings.value,
                                                                onChange: _cache[6] || (_cache[6] = function ($event) { return (saveMaxConcurrentCaregivers($event.target.valueAsNumber)); })
                                                            }, null, 40, _hoisted_17)
                                                        ]),
                                                        _cache[49] || (_cache[49] = (0, vue_2.createElementVNode)("div", { class: "settings-item settings-item-action" }, [
                                                            (0, vue_2.createElementVNode)("span", { class: "settings-label" }, [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-pencil-square" }),
                                                                (0, vue_2.createTextVNode)(" Edit Matrices ")
                                                            ]),
                                                            (0, vue_2.createElementVNode)("span", { class: "settings-badge" }, "Coming soon")
                                                        ], -1))
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ]; }, undefined, true),
                                            _: 1
                                        })
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true),
                        _cache[104] || (_cache[104] = (0, vue_2.createElementVNode)("div", { class: "tab-separator" }, null, -1)),
                        (0, vue_2.createVNode)(vue_2.Transition, { name: "perm-alert" }, {
                            default: (0, vue_2.withCtx)(function () { return [
                                (permissionAlert.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_18, [
                                        _cache[51] || (_cache[51] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-warning-sign bi-exclamation-triangle-fill" }, null, -1)),
                                        _cache[52] || (_cache[52] = (0, vue_2.createTextVNode)(" You don't have adequate permissions to access Settings. ", -1)),
                                        (0, vue_2.createElementVNode)("button", {
                                            class: "perm-alert-close",
                                            onClick: _cache[7] || (_cache[7] = function ($event) { return (permissionAlert.value = false); })
                                        }, __spreadArray([], (_cache[50] || (_cache[50] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-x-lg" }, null, -1)
                                        ])), true))
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ]; }, undefined, true),
                            _: 1
                        }),
                        (pageMode.value === 'patient')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(PatientAvailability_vue_1.default, {
                                key: 1,
                                accountnumber: staffContext.value.externId2,
                                "show-matrix": showMatrix.value,
                                "enable-environment-tabs": enableEnvironmentTabs.value,
                                access: (0, vue_2.unref)(access)
                            }, null, 8, ["accountnumber", "show-matrix", "enable-environment-tabs", "access"]))
                            : (0, vue_2.createCommentVNode)("", true),
                        (pageMode.value === 'staff')
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 2 }, [
                                (0, vue_2.createElementVNode)("div", _hoisted_19, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                        _cache[53] || (_cache[53] = (0, vue_2.createElementVNode)("span", { class: "title-icon glyphicon bi-calendar-event" }, null, -1)),
                                        (0, vue_2.createElementVNode)("div", null, [
                                            (0, vue_2.createElementVNode)("h1", null, (0, vue_2.toDisplayString)(staffRole.value === 'nurse' ? 'Nurse Scheduling' : 'Provider Scheduling'), 1),
                                            (0, vue_2.createElementVNode)("p", null, (0, vue_2.toDisplayString)(staffRole.value === 'nurse'
                                                ? 'Configure shift increments and availability used to plan nurse & aide coverage'
                                                : 'Manage provider availability and time off used to confirm appointments'), 1)
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                        (((_b = (0, vue_2.unref)(access)) === null || _b === void 0 ? void 0 : _b.kind) === 'admin')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                                    _cache[55] || (_cache[55] = (0, vue_2.createElementVNode)("label", { class: "staff-type-label" }, "Caregiver Type", -1)),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = function ($event) { return ((activeCategory).value = $event); }),
                                                        class: "caregiver-type-select"
                                                    }, __spreadArray([], (_cache[54] || (_cache[54] = [
                                                        (0, vue_2.createStaticVNode)("<optgroup label=\"Providers\" data-v-2d33350c><option value=\"provider\" data-v-2d33350c>Physician</option><option value=\"allied\" data-v-2d33350c>Allied Professional</option></optgroup><optgroup label=\"Nurses\" data-v-2d33350c><option value=\"nurse\" data-v-2d33350c>Nurse</option><option value=\"hha\" data-v-2d33350c>HHA</option></optgroup>", 2)
                                                    ])), true), 512), [
                                                        [vue_2.vModelSelect, activeCategory.value]
                                                    ])
                                                ]),
                                                (staffRole.value === 'nurse')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, [
                                                        (0, vue_2.createElementVNode)("label", _hoisted_24, [
                                                            (0, vue_2.createElementVNode)("input", {
                                                                type: "checkbox",
                                                                checked: shiftPreset.value === 'regular',
                                                                onChange: _cache[9] || (_cache[9] = function ($event) { return (setShiftPreset('regular')); })
                                                            }, null, 40, _hoisted_25),
                                                            _cache[56] || (_cache[56] = (0, vue_2.createTextVNode)(" Use standard scheduling ", -1))
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                class: (0, vue_2.normalizeClass)(['shift-preset-btn', { active: shiftPreset.value === 'day' }]),
                                                                onClick: _cache[10] || (_cache[10] = function ($event) { return (setShiftPreset('day')); })
                                                            }, "Day Shift", 2),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                type: "button",
                                                                class: (0, vue_2.normalizeClass)(['shift-preset-btn night', { active: shiftPreset.value === 'night' }]),
                                                                onClick: _cache[11] || (_cache[11] = function ($event) { return (setShiftPreset('night')); })
                                                            }, "Night Shift", 2)
                                                        ])
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                                    (0, vue_2.createElementVNode)("label", _hoisted_28, (0, vue_2.toDisplayString)(activeCategoryLabel.value), 1),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((selectedStaffId).value = $event); }),
                                                        class: "provider-select"
                                                    }, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(filteredStaffList.value, function (s) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                key: s.id,
                                                                value: s.id
                                                            }, (0, vue_2.toDisplayString)(s.name) + (0, vue_2.toDisplayString)(s.credential ? ', ' + s.credential : '') + " — " + (0, vue_2.toDisplayString)(s.specialty), 9, _hoisted_29));
                                                        }), 128))
                                                    ], 512), [
                                                        [vue_2.vModelSelect, selectedStaffId.value]
                                                    ])
                                                ])
                                            ], 64))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_30, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_31, (0, vue_2.toDisplayString)(activeCategoryLabel.value), 1),
                                                (0, vue_2.createElementVNode)("span", _hoisted_32, [
                                                    (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(selectedStaffName.value || 'You'), 1)
                                                ])
                                            ]))
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                        (staffRole.value === 'nurse')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("section", _hoisted_35, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                                        _cache[57] || (_cache[57] = (0, vue_2.createElementVNode)("h2", null, [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-gear" }),
                                                            (0, vue_2.createTextVNode)(" Shift Time Settings")
                                                        ], -1)),
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: (0, vue_2.normalizeClass)(["cat-badge", activeCategory.value])
                                                        }, (0, vue_2.toDisplayString)(activeCategory.value === 'hha' ? 'HHA' : 'Nurse'), 3)
                                                    ]),
                                                    (0, vue_2.createElementVNode)("span", _hoisted_38, [
                                                        _cache[58] || (_cache[58] = (0, vue_2.createTextVNode)(" Custom shift increments for all ", -1)),
                                                        (0, vue_2.createElementVNode)("strong", null, (0, vue_2.toDisplayString)(activeCategory.value === 'hha' ? 'HHA' : 'Nurse'), 1),
                                                        _cache[59] || (_cache[59] = (0, vue_2.createTextVNode)(" staff — saved separately per caregiver type, independent of Medicaid/Medicare billing increments ", -1))
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                                                            _cache[60] || (_cache[60] = (0, vue_2.createElementVNode)("label", null, "MINIMUM SHIFT LENGTH", -1)),
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((shiftSettings.minIncrementMinutes) = $event); })
                                                            }, [
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(shiftLengthOptions.value, function (opt) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                        key: opt.value,
                                                                        value: opt.value
                                                                    }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_42));
                                                                }), 128))
                                                            ], 512), [
                                                                [
                                                                    vue_2.vModelSelect,
                                                                    shiftSettings.minIncrementMinutes,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                                            _cache[61] || (_cache[61] = (0, vue_2.createElementVNode)("label", null, "MAXIMUM SHIFT LENGTH", -1)),
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                "onUpdate:modelValue": _cache[14] || (_cache[14] = function ($event) { return ((shiftSettings.maxIncrementMinutes) = $event); })
                                                            }, [
                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(shiftLengthOptions.value, function (opt) {
                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                        key: opt.value,
                                                                        value: opt.value
                                                                    }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_44));
                                                                }), 128))
                                                            ], 512), [
                                                                [
                                                                    vue_2.vModelSelect,
                                                                    shiftSettings.maxIncrementMinutes,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_45, [
                                                            _cache[62] || (_cache[62] = (0, vue_2.createElementVNode)("label", null, "INCREMENT STEP", -1)),
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                                "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) { return ((shiftSettings.stepMinutes) = $event); })
                                                            }, [
                                                                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(stepOptions, function (opt) {
                                                                    return (0, vue_2.createElementVNode)("option", {
                                                                        key: opt.value,
                                                                        value: opt.value
                                                                    }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_46);
                                                                }), 64))
                                                            ], 512), [
                                                                [
                                                                    vue_2.vModelSelect,
                                                                    shiftSettings.stepMinutes,
                                                                    void 0,
                                                                    { number: true }
                                                                ]
                                                            ])
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                                            _cache[64] || (_cache[64] = (0, vue_2.createElementVNode)("label", null, "CONCURRENT MAX HOURS", -1)),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_48, [
                                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                    type: "number",
                                                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) { return ((shiftSettings.maxConsecutiveHours) = $event); }),
                                                                    min: "1",
                                                                    max: "24"
                                                                }, null, 512), [
                                                                    [
                                                                        vue_2.vModelText,
                                                                        shiftSettings.maxConsecutiveHours,
                                                                        void 0,
                                                                        { number: true }
                                                                    ]
                                                                ]),
                                                                _cache[63] || (_cache[63] = (0, vue_2.createElementVNode)("p", { class: "max-hours-note" }, "Hard cap on consecutive scheduled hours across back-to-back shifts", -1))
                                                            ])
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", _hoisted_49, [
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: "btn-save-settings",
                                                            onClick: saveShiftSettingsEntry,
                                                            disabled: savingShiftSettings.value
                                                        }, [
                                                            (savingShiftSettings.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_51))
                                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_52)),
                                                            _cache[65] || (_cache[65] = (0, vue_2.createTextVNode)(" Save Settings ", -1))
                                                        ], 8, _hoisted_50)
                                                    ])
                                                ])
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("section", _hoisted_53, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                                _cache[66] || (_cache[66] = (0, vue_2.createElementVNode)("h2", null, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-repeat bi-repeat" }),
                                                    (0, vue_2.createTextVNode)(" Weekly Availability")
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("span", _hoisted_55, (0, vue_2.toDisplayString)(staffRole.value === 'nurse'
                                                    ? "Recurring shift windows ".concat(selectedStaffName.value, " can be scheduled")
                                                    : "Recurring hours ".concat(selectedStaffName.value, " is open for appointments")), 1)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", _hoisted_56, [
                                                ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(weekDays, function (day) {
                                                    return (0, vue_2.createElementVNode)("div", {
                                                        key: day.value,
                                                        class: "day-row"
                                                    }, [
                                                        (0, vue_2.createElementVNode)("div", {
                                                            class: (0, vue_2.normalizeClass)(["day-label", { 'has-rules': rulesForDay(day.value).length }])
                                                        }, (0, vue_2.toDisplayString)(day.label), 3),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_57, [
                                                            (0, vue_2.createVNode)(vue_2.TransitionGroup, { name: "rule-fade" }, {
                                                                default: (0, vue_2.withCtx)(function () { return [
                                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(rulesForDay(day.value), function (rule) {
                                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                            key: rule.id,
                                                                            class: "rule-chip"
                                                                        }, [
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_58, (0, vue_2.toDisplayString)(formatTime(rule.startTime)) + " – " + (0, vue_2.toDisplayString)(formatTime(rule.endTime)), 1),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_59, (0, vue_2.toDisplayString)(staffRole.value === 'nurse' ? formatDuration(rule.slotMinutes) : rule.slotMinutes + 'm'), 1),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                class: "chip-btn",
                                                                                title: "Edit",
                                                                                onClick: function ($event) { return (openRuleModal(day.value, rule)); }
                                                                            }, __spreadArray([], (_cache[67] || (_cache[67] = [
                                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil bi-pencil" }, null, -1)
                                                                            ])), true), 8, _hoisted_60),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                class: "chip-btn danger",
                                                                                title: "Remove",
                                                                                onClick: function ($event) { return (removeRule(rule.id)); }
                                                                            }, __spreadArray([], (_cache[68] || (_cache[68] = [
                                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                                                            ])), true), 8, _hoisted_61)
                                                                        ]));
                                                                    }), 128))
                                                                ]; }, undefined, true),
                                                                _: 2
                                                            }, 1024),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: "add-rule-btn",
                                                                onClick: function ($event) { return (openRuleModal(day.value)); }
                                                            }, __spreadArray([], (_cache[69] || (_cache[69] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-plus bi bi-plus" }, null, -1),
                                                                (0, vue_2.createTextVNode)(" Add hours ", -1)
                                                            ])), true), 8, _hoisted_62)
                                                        ])
                                                    ]);
                                                }), 64))
                                            ])
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_63, [
                                        (0, vue_2.createElementVNode)("section", _hoisted_64, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_65, [
                                                _cache[71] || (_cache[71] = (0, vue_2.createElementVNode)("h2", null, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ban-circle bi-ban" }),
                                                    (0, vue_2.createTextVNode)(" Time Off")
                                                ], -1)),
                                                (0, vue_2.createElementVNode)("button", {
                                                    class: "btn-add",
                                                    onClick: _cache[17] || (_cache[17] = function ($event) { return (openTimeOffModal()); })
                                                }, __spreadArray([], (_cache[70] || (_cache[70] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-plus" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" Add ", -1)
                                                ])), true))
                                            ]),
                                            (timeOff.value.length === 0)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_66, __spreadArray([], (_cache[72] || (_cache[72] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle bi bi-check" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" No upcoming time off scheduled ", -1)
                                                ])), true)))
                                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.TransitionGroup, {
                                                    key: 1,
                                                    name: "rule-fade",
                                                    tag: "div",
                                                    class: "timeoff-list"
                                                }, {
                                                    default: (0, vue_2.withCtx)(function () { return [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(timeOff.value, function (off) {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                key: off.id,
                                                                class: "timeoff-item"
                                                            }, [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_68, (0, vue_2.toDisplayString)(formatDateShort(off.offDate)), 1),
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_69, (0, vue_2.toDisplayString)(off.startTime ? "".concat(formatTime(off.startTime), " \u2013 ").concat(formatTime(off.endTime)) : 'All day'), 1)
                                                                ]),
                                                                (0, vue_2.createElementVNode)("span", _hoisted_70, (0, vue_2.toDisplayString)(off.reason || '—'), 1),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_71, [
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        class: "chip-btn",
                                                                        title: "Edit",
                                                                        onClick: function ($event) { return (openTimeOffModal(off)); }
                                                                    }, __spreadArray([], (_cache[73] || (_cache[73] = [
                                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-pencil bi-pencil" }, null, -1)
                                                                    ])), true), 8, _hoisted_72),
                                                                    (0, vue_2.createElementVNode)("button", {
                                                                        class: "chip-btn danger",
                                                                        title: "Remove",
                                                                        onClick: function ($event) { return (removeTimeOff(off.id)); }
                                                                    }, __spreadArray([], (_cache[74] || (_cache[74] = [
                                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-trash bi-trash" }, null, -1)
                                                                    ])), true), 8, _hoisted_73)
                                                                ])
                                                            ]));
                                                        }), 128))
                                                    ]; }, undefined, true),
                                                    _: 1
                                                }))
                                        ]),
                                        (0, vue_2.createElementVNode)("section", _hoisted_74, [
                                            _cache[82] || (_cache[82] = (0, vue_2.createElementVNode)("div", { class: "panel-header" }, [
                                                (0, vue_2.createElementVNode)("h2", null, [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-eye-open" }),
                                                    (0, vue_2.createTextVNode)(" Availability Preview")
                                                ]),
                                                (0, vue_2.createElementVNode)("span", { class: "panel-sub" }, "Cross-references hours, time off & booked slots")
                                            ], -1)),
                                            (0, vue_2.createElementVNode)("div", _hoisted_75, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                    type: "date",
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) { return ((previewDate).value = $event); }),
                                                    class: "preview-date",
                                                    min: (0, vue_2.unref)(todayStr)
                                                }, null, 8, _hoisted_76), [
                                                    [vue_2.vModelText, previewDate.value]
                                                ])
                                            ]),
                                            (loadingPreview.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_77, __spreadArray([], (_cache[75] || (_cache[75] = [
                                                    (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-refresh spinning" }, null, -1),
                                                    (0, vue_2.createTextVNode)(" Calculating open slots... ", -1)
                                                ])), true)))
                                                : (previewSlots.value.length === 0)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_78, __spreadArray([], (_cache[76] || (_cache[76] = [
                                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-info-sign" }, null, -1),
                                                        (0, vue_2.createTextVNode)(" No hours configured for this weekday ", -1)
                                                    ])), true)))
                                                    : (staffRole.value === 'provider')
                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_79, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(previewSlots.value, function (slot) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                    key: slot.value,
                                                                    class: (0, vue_2.normalizeClass)(["preview-slot", { taken: !slot.available }]),
                                                                    title: slot.available ? 'Open' : 'Booked or time off'
                                                                }, (0, vue_2.toDisplayString)(slot.label), 11, _hoisted_80));
                                                            }), 128))
                                                        ]))
                                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_81, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(previewSlots.value, function (slot) {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                                    key: slot.value,
                                                                    class: (0, vue_2.normalizeClass)(["shift-block", shiftBlockClass(slot)])
                                                                }, [
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_82, [
                                                                        (0, vue_2.createElementVNode)("span", _hoisted_83, (0, vue_2.toDisplayString)(slot.label), 1),
                                                                        _cache[77] || (_cache[77] = (0, vue_2.createElementVNode)("span", { class: "shift-sep" }, " – ", -1)),
                                                                        (0, vue_2.createElementVNode)("span", _hoisted_84, (0, vue_2.toDisplayString)(slot.endLabel), 1)
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_85, (0, vue_2.toDisplayString)(formatDuration(slot.durationMinutes)), 1),
                                                                    (0, vue_2.createElementVNode)("span", _hoisted_86, (0, vue_2.toDisplayString)(shiftStatusLabel(slot)), 1)
                                                                ], 2));
                                                            }), 128))
                                                        ])),
                                            (0, vue_2.createElementVNode)("div", _hoisted_87, [
                                                _cache[80] || (_cache[80] = (0, vue_2.createElementVNode)("span", null, [
                                                    (0, vue_2.createElementVNode)("i", { class: "dot open" }),
                                                    (0, vue_2.createTextVNode)(" Open")
                                                ], -1)),
                                                _cache[81] || (_cache[81] = (0, vue_2.createElementVNode)("span", null, [
                                                    (0, vue_2.createElementVNode)("i", { class: "dot taken" }),
                                                    (0, vue_2.createTextVNode)(" Booked / Off")
                                                ], -1)),
                                                (staffRole.value === 'nurse')
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                                                        _cache[78] || (_cache[78] = (0, vue_2.createElementVNode)("span", null, [
                                                            (0, vue_2.createElementVNode)("i", { class: "dot warning" }),
                                                            (0, vue_2.createTextVNode)(" At Cap")
                                                        ], -1)),
                                                        _cache[79] || (_cache[79] = (0, vue_2.createElementVNode)("span", null, [
                                                            (0, vue_2.createElementVNode)("i", { class: "dot capped" }),
                                                            (0, vue_2.createTextVNode)(" Over Cap")
                                                        ], -1))
                                                    ], 64))
                                                    : (0, vue_2.createCommentVNode)("", true)
                                            ])
                                        ])
                                    ])
                                ]),
                                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                                    (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (ruleModalOpen.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                    key: 0,
                                                    class: "modal-overlay",
                                                    onClick: _cache[25] || (_cache[25] = (0, vue_2.withModifiers)(function ($event) { return (ruleModalOpen.value = false); }, ["self"]))
                                                }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_88, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_89, [
                                                            (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(editingRule.id ? 'Edit' : 'Add') + " Hours — " + (0, vue_2.toDisplayString)(dayLabel(editingRule.dayOfWeek)) + " | " + (0, vue_2.toDisplayString)(selectedStaffName.value), 1),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: "close-x",
                                                                onClick: _cache[19] || (_cache[19] = function ($event) { return (ruleModalOpen.value = false); })
                                                            }, __spreadArray([], (_cache[83] || (_cache[83] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi bi-x-lg" }, null, -1)
                                                            ])), true))
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_90, [
                                                            (0, vue_2.createElementVNode)("div", _hoisted_91, [
                                                                (0, vue_2.createElementVNode)("div", _hoisted_92, [
                                                                    _cache[84] || (_cache[84] = (0, vue_2.createElementVNode)("label", null, "Start", -1)),
                                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                        type: "time",
                                                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) { return ((editingRule.startTime) = $event); }),
                                                                        step: "900"
                                                                    }, null, 512), [
                                                                        [vue_2.vModelText, editingRule.startTime]
                                                                    ])
                                                                ]),
                                                                (0, vue_2.createElementVNode)("div", _hoisted_93, [
                                                                    _cache[85] || (_cache[85] = (0, vue_2.createElementVNode)("label", null, "End", -1)),
                                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                        type: "time",
                                                                        "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) { return ((editingRule.endTime) = $event); }),
                                                                        step: "900"
                                                                    }, null, 512), [
                                                                        [vue_2.vModelText, editingRule.endTime]
                                                                    ])
                                                                ])
                                                            ]),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_94, [
                                                                (0, vue_2.createElementVNode)("label", null, (0, vue_2.toDisplayString)(staffRole.value === 'nurse' ? 'Shift Duration' : 'Appointment Length'), 1),
                                                                (staffRole.value === 'provider')
                                                                    ? (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("select", {
                                                                        key: 0,
                                                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) { return ((editingRule.slotMinutes) = $event); })
                                                                    }, __spreadArray([], (_cache[86] || (_cache[86] = [
                                                                        (0, vue_2.createElementVNode)("option", { value: 15 }, "15 minutes", -1),
                                                                        (0, vue_2.createElementVNode)("option", { value: 20 }, "20 minutes", -1),
                                                                        (0, vue_2.createElementVNode)("option", { value: 30 }, "30 minutes", -1),
                                                                        (0, vue_2.createElementVNode)("option", { value: 45 }, "45 minutes", -1),
                                                                        (0, vue_2.createElementVNode)("option", { value: 60 }, "60 minutes", -1)
                                                                    ])), true), 512)), [
                                                                        [
                                                                            vue_2.vModelSelect,
                                                                            editingRule.slotMinutes,
                                                                            void 0,
                                                                            { number: true }
                                                                        ]
                                                                    ])
                                                                    : (0, vue_2.withDirectives)(((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("select", {
                                                                        key: 1,
                                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) { return ((editingRule.slotMinutes) = $event); })
                                                                    }, [
                                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(nurseSlotOptions.value, function (opt) {
                                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("option", {
                                                                                key: opt.value,
                                                                                value: opt.value
                                                                            }, (0, vue_2.toDisplayString)(opt.label), 9, _hoisted_95));
                                                                        }), 128))
                                                                    ], 512)), [
                                                                        [
                                                                            vue_2.vModelSelect,
                                                                            editingRule.slotMinutes,
                                                                            void 0,
                                                                            { number: true }
                                                                        ]
                                                                    ])
                                                            ]),
                                                            (ruleError.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_96, (0, vue_2.toDisplayString)(ruleError.value), 1))
                                                                : (0, vue_2.createCommentVNode)("", true)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_97, [
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: "btn-cancel",
                                                                onClick: _cache[24] || (_cache[24] = function ($event) { return (ruleModalOpen.value = false); })
                                                            }, "Cancel"),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: "btn-save",
                                                                onClick: saveRule,
                                                                disabled: savingRule.value
                                                            }, [
                                                                (savingRule.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_99))
                                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_100)),
                                                                _cache[87] || (_cache[87] = (0, vue_2.createTextVNode)(" Save Hours ", -1))
                                                            ], 8, _hoisted_98)
                                                        ])
                                                    ])
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]; }, undefined, true),
                                        _: 1
                                    })
                                ])),
                                ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(vue_2.Teleport, { to: "body" }, [
                                    (0, vue_2.createVNode)(vue_2.Transition, { name: "modal" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (timeOffModalOpen.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                                    key: 0,
                                                    class: "modal-overlay",
                                                    onClick: _cache[34] || (_cache[34] = (0, vue_2.withModifiers)(function ($event) { return (timeOffModalOpen.value = false); }, ["self"]))
                                                }, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_101, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_102, [
                                                            (0, vue_2.createElementVNode)("h3", null, (0, vue_2.toDisplayString)(editingTimeOff.id ? 'Edit' : 'Add') + " Time Off | " + (0, vue_2.toDisplayString)(selectedStaffName.value), 1),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: "close-x",
                                                                onClick: _cache[26] || (_cache[26] = function ($event) { return (timeOffModalOpen.value = false); })
                                                            }, __spreadArray([], (_cache[88] || (_cache[88] = [
                                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-remove bi-x-lg" }, null, -1)
                                                            ])), true))
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_103, [
                                                            (editingTimeOff.id)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_104, [
                                                                    _cache[89] || (_cache[89] = (0, vue_2.createElementVNode)("label", null, "Date", -1)),
                                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                        type: "date",
                                                                        "onUpdate:modelValue": _cache[27] || (_cache[27] = function ($event) { return ((editingTimeOff.offDate) = $event); }),
                                                                        min: (0, vue_2.unref)(todayStr)
                                                                    }, null, 8, _hoisted_105), [
                                                                        [vue_2.vModelText, editingTimeOff.offDate]
                                                                    ])
                                                                ]))
                                                                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_106, [
                                                                    _cache[98] || (_cache[98] = (0, vue_2.createElementVNode)("label", { class: "field-label" }, [
                                                                        (0, vue_2.createTextVNode)("Select Date(s) "),
                                                                        (0, vue_2.createElementVNode)("span", { class: "optional" }, "— click any day to toggle; click ↔ to select a week")
                                                                    ], -1)),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_107, [
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_108, [
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                type: "button",
                                                                                class: "cal-nav-btn",
                                                                                onClick: toCalPrevMonth
                                                                            }, "‹"),
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_109, (0, vue_2.toDisplayString)(toCalMonthLabel.value), 1),
                                                                            (0, vue_2.createElementVNode)("button", {
                                                                                type: "button",
                                                                                class: "cal-nav-btn",
                                                                                onClick: toCalNextMonth
                                                                            }, "›")
                                                                        ]),
                                                                        (0, vue_2.createElementVNode)("div", _hoisted_110, [
                                                                            _cache[90] || (_cache[90] = (0, vue_2.createElementVNode)("span", { class: "cal-wday-spacer" }, null, -1)),
                                                                            _cache[91] || (_cache[91] = (0, vue_2.createElementVNode)("span", { class: "cal-wday" }, "Su", -1)),
                                                                            _cache[92] || (_cache[92] = (0, vue_2.createElementVNode)("span", { class: "cal-wday" }, "Mo", -1)),
                                                                            _cache[93] || (_cache[93] = (0, vue_2.createElementVNode)("span", { class: "cal-wday" }, "Tu", -1)),
                                                                            _cache[94] || (_cache[94] = (0, vue_2.createElementVNode)("span", { class: "cal-wday" }, "We", -1)),
                                                                            _cache[95] || (_cache[95] = (0, vue_2.createElementVNode)("span", { class: "cal-wday" }, "Th", -1)),
                                                                            _cache[96] || (_cache[96] = (0, vue_2.createElementVNode)("span", { class: "cal-wday" }, "Fr", -1)),
                                                                            _cache[97] || (_cache[97] = (0, vue_2.createElementVNode)("span", { class: "cal-wday" }, "Sa", -1)),
                                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(toCalWeeks.value, function (week, wi) {
                                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: wi }, [
                                                                                    (0, vue_2.createElementVNode)("button", {
                                                                                        type: "button",
                                                                                        class: "cal-week-btn",
                                                                                        title: 'Select / deselect week ' + (wi + 1),
                                                                                        onClick: function ($event) { return (toggleTimeOffWeek(week)); }
                                                                                    }, "↔", 8, _hoisted_111),
                                                                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(week, function (cell) {
                                                                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                                            key: cell.dateStr || ('empty-' + wi + cell.col),
                                                                                            type: "button",
                                                                                            class: (0, vue_2.normalizeClass)(["cal-cell", { empty: !cell.dateStr, past: cell.isPast, selected: cell.dateStr && selectedTimeOffDates.value.includes(cell.dateStr) }]),
                                                                                            disabled: !cell.dateStr || cell.isPast,
                                                                                            onClick: function ($event) { return (cell.dateStr && !cell.isPast && toggleTimeOffDate(cell.dateStr)); }
                                                                                        }, (0, vue_2.toDisplayString)(cell.label), 11, _hoisted_112));
                                                                                    }), 128))
                                                                                ], 64));
                                                                            }), 128))
                                                                        ])
                                                                    ]),
                                                                    (selectedTimeOffDates.value.length)
                                                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_113, [
                                                                            (0, vue_2.createElementVNode)("span", _hoisted_114, (0, vue_2.toDisplayString)(selectedTimeOffDates.value.length) + " day" + (0, vue_2.toDisplayString)(selectedTimeOffDates.value.length > 1 ? 's' : '') + " selected:", 1),
                                                                            (0, vue_2.createElementVNode)("div", _hoisted_115, [
                                                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(selectedTimeOffDates.value, function (d) {
                                                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                                        key: d,
                                                                                        class: "date-chip",
                                                                                        onClick: function ($event) { return (toggleTimeOffDate(d)); },
                                                                                        title: "Click to remove"
                                                                                    }, (0, vue_2.toDisplayString)(formatDateShort(d)) + " ×", 9, _hoisted_116));
                                                                                }), 128))
                                                                            ]),
                                                                            (selectedTimeOffDates.value.length > 1)
                                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                                                                    key: 0,
                                                                                    type: "button",
                                                                                    class: "clear-all-btn",
                                                                                    onClick: _cache[28] || (_cache[28] = function ($event) { return (selectedTimeOffDates.value = []); })
                                                                                }, "Clear all"))
                                                                                : (0, vue_2.createCommentVNode)("", true)
                                                                        ]))
                                                                        : (0, vue_2.createCommentVNode)("", true)
                                                                ])),
                                                            (0, vue_2.createElementVNode)("label", _hoisted_117, [
                                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                    type: "checkbox",
                                                                    "onUpdate:modelValue": _cache[29] || (_cache[29] = function ($event) { return ((allDayOff).value = $event); })
                                                                }, null, 512), [
                                                                    [vue_2.vModelCheckbox, allDayOff.value]
                                                                ]),
                                                                _cache[99] || (_cache[99] = (0, vue_2.createTextVNode)(" All day ", -1))
                                                            ]),
                                                            (!allDayOff.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_118, [
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_119, [
                                                                        _cache[100] || (_cache[100] = (0, vue_2.createElementVNode)("label", null, "From", -1)),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            type: "time",
                                                                            "onUpdate:modelValue": _cache[30] || (_cache[30] = function ($event) { return ((editingTimeOff.startTime) = $event); }),
                                                                            step: "900"
                                                                        }, null, 512), [
                                                                            [vue_2.vModelText, editingTimeOff.startTime]
                                                                        ])
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("div", _hoisted_120, [
                                                                        _cache[101] || (_cache[101] = (0, vue_2.createElementVNode)("label", null, "To", -1)),
                                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                            type: "time",
                                                                            "onUpdate:modelValue": _cache[31] || (_cache[31] = function ($event) { return ((editingTimeOff.endTime) = $event); }),
                                                                            step: "900"
                                                                        }, null, 512), [
                                                                            [vue_2.vModelText, editingTimeOff.endTime]
                                                                        ])
                                                                    ])
                                                                ]))
                                                                : (0, vue_2.createCommentVNode)("", true),
                                                            (0, vue_2.createElementVNode)("div", _hoisted_121, [
                                                                _cache[102] || (_cache[102] = (0, vue_2.createElementVNode)("label", null, [
                                                                    (0, vue_2.createTextVNode)("Reason "),
                                                                    (0, vue_2.createElementVNode)("span", { class: "optional" }, "(optional)")
                                                                ], -1)),
                                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                    type: "text",
                                                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = function ($event) { return ((editingTimeOff.reason) = $event); }),
                                                                    placeholder: "e.g. Vacation, Conference, PTO"
                                                                }, null, 512), [
                                                                    [vue_2.vModelText, editingTimeOff.reason]
                                                                ])
                                                            ]),
                                                            (timeOffError.value)
                                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("p", _hoisted_122, (0, vue_2.toDisplayString)(timeOffError.value), 1))
                                                                : (0, vue_2.createCommentVNode)("", true)
                                                        ]),
                                                        (0, vue_2.createElementVNode)("div", _hoisted_123, [
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: "btn-cancel",
                                                                onClick: _cache[33] || (_cache[33] = function ($event) { return (timeOffModalOpen.value = false); })
                                                            }, "Cancel"),
                                                            (0, vue_2.createElementVNode)("button", {
                                                                class: "btn-save",
                                                                onClick: saveTimeOffEntry,
                                                                disabled: savingTimeOff.value
                                                            }, [
                                                                (savingTimeOff.value)
                                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_125))
                                                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_126)),
                                                                _cache[103] || (_cache[103] = (0, vue_2.createTextVNode)(" Save Time Off ", -1))
                                                            ], 8, _hoisted_124)
                                                        ])
                                                    ])
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]; }, undefined, true),
                                        _: 1
                                    })
                                ]))
                            ], 64))
                            : (0, vue_2.createCommentVNode)("", true)
                    ], 64))
                    : (topTab.value === 'scheduling')
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_127, [
                                (canAccessAppointmentsTab.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_128, [
                                        (0, vue_2.createElementVNode)("button", {
                                            role: "tab",
                                            "aria-selected": schedulingSubTab.value === 'appointments',
                                            class: (0, vue_2.normalizeClass)(['page-tab', { active: schedulingSubTab.value === 'appointments' }]),
                                            onClick: _cache[35] || (_cache[35] = function ($event) { return (schedulingSubTab.value = 'appointments'); })
                                        }, __spreadArray([], (_cache[105] || (_cache[105] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-calendar-check" }, null, -1),
                                            (0, vue_2.createTextVNode)(" Appointments ", -1)
                                        ])), true), 10, _hoisted_129),
                                        (0, vue_2.createElementVNode)("button", {
                                            role: "tab",
                                            "aria-selected": schedulingSubTab.value === 'calendar',
                                            class: (0, vue_2.normalizeClass)(['page-tab', { active: schedulingSubTab.value === 'calendar' }]),
                                            onClick: _cache[36] || (_cache[36] = function ($event) { return (schedulingSubTab.value = 'calendar'); })
                                        }, __spreadArray([], (_cache[106] || (_cache[106] = [
                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-calendar3" }, null, -1),
                                            (0, vue_2.createTextVNode)(" Calendar ", -1)
                                        ])), true), 10, _hoisted_130)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true),
                                (0, vue_2.createElementVNode)("div", _hoisted_131, [
                                    (0, vue_2.createElementVNode)("button", {
                                        class: (0, vue_2.normalizeClass)(['tab-settings-btn', { open: calendarSettingsOpen.value }]),
                                        onClick: onCalendarSettingsClick,
                                        title: "Calendar Settings"
                                    }, __spreadArray([], (_cache[107] || (_cache[107] = [
                                        (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-gear-fill" }, null, -1),
                                        (0, vue_2.createTextVNode)(" Settings ", -1)
                                    ])), true), 2),
                                    (calendarSettingsOpen.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: 0,
                                            class: "settings-backdrop",
                                            onClick: _cache[37] || (_cache[37] = function ($event) { return (calendarSettingsOpen.value = false); })
                                        }))
                                        : (0, vue_2.createCommentVNode)("", true),
                                    (0, vue_2.createVNode)(vue_2.Transition, { name: "settings-drop" }, {
                                        default: (0, vue_2.withCtx)(function () { return [
                                            (calendarSettingsOpen.value)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_132, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_133, [
                                                        _cache[109] || (_cache[109] = (0, vue_2.createElementVNode)("span", { class: "settings-label" }, [
                                                            (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-layout-text-window-reverse" }),
                                                            (0, vue_2.createTextVNode)(" Show Supporting Cards ")
                                                        ], -1)),
                                                        (0, vue_2.createElementVNode)("button", {
                                                            class: (0, vue_2.normalizeClass)(['toggle-sw', { on: showSupportingCards.value }]),
                                                            onClick: toggleShowSupportingCards,
                                                            disabled: savingUiSettings.value,
                                                            title: showSupportingCards.value ? 'Hide supporting cards' : 'Show supporting cards'
                                                        }, __spreadArray([], (_cache[108] || (_cache[108] = [
                                                            (0, vue_2.createElementVNode)("span", { class: "toggle-knob" }, null, -1)
                                                        ])), true), 10, _hoisted_134)
                                                    ])
                                                ]))
                                                : (0, vue_2.createCommentVNode)("", true)
                                        ]; }, undefined, true),
                                        _: 1
                                    })
                                ])
                            ]),
                            (0, vue_2.createVNode)(vue_2.Transition, { name: "perm-alert" }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    (calendarPermissionAlert.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_135, [
                                            _cache[111] || (_cache[111] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-warning-sign bi-exclamation-triangle-fill" }, null, -1)),
                                            _cache[112] || (_cache[112] = (0, vue_2.createTextVNode)(" You don't have adequate permissions to access Settings. ", -1)),
                                            (0, vue_2.createElementVNode)("button", {
                                                class: "perm-alert-close",
                                                onClick: _cache[38] || (_cache[38] = function ($event) { return (calendarPermissionAlert.value = false); })
                                            }, __spreadArray([], (_cache[110] || (_cache[110] = [
                                                (0, vue_2.createElementVNode)("span", { class: "glyphicon bi-x-lg" }, null, -1)
                                            ])), true))
                                        ]))
                                        : (0, vue_2.createCommentVNode)("", true)
                                ]; }, undefined, true),
                                _: 1
                            }),
                            _cache[113] || (_cache[113] = (0, vue_2.createElementVNode)("div", { class: "tab-separator" }, null, -1)),
                            (canAccessAppointmentsTab.value && schedulingSubTab.value === 'appointments')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SchedulingCalendar_vue_1.default, {
                                    key: 0,
                                    ref_key: "schedulingCalendarRef",
                                    ref: schedulingCalendarRef,
                                    accountnumber: staffContext.value.externId2,
                                    access: (0, vue_2.unref)(access),
                                    "actor-id": staffContext.value.externId
                                }, null, 8, ["accountnumber", "access", "actor-id"]))
                                : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(MasterCalendar_vue_1.default, {
                                    key: 1,
                                    accountnumber: staffContext.value.externId2,
                                    access: (0, vue_2.unref)(access),
                                    "show-supporting-cards": showSupportingCards.value,
                                    onEditInScheduler: onEditInScheduler,
                                    onToast: showToast
                                }, null, 8, ["accountnumber", "access", "show-supporting-cards"]))
                        ], 64))
                        : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createVNode)(vue_2.Transition, { name: "toast" }, {
                    default: (0, vue_2.withCtx)(function () { return [
                        (toast.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_136, [
                                _cache[114] || (_cache[114] = (0, vue_2.createElementVNode)("span", { class: "glyphicon glyphicon-ok-circle bi-check-circle" }, null, -1)),
                                (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(toast.value), 1)
                            ]))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]; }, undefined, true),
                    _: 1
                })
            ]));
        };
    }
});
